import { $, $$, setAttributes } from '@3pc/dom';
import { uniqueId } from 'utils/helper';
import { Accordion } from '@3pc/accordion';

const accordions = $$('.accordion__item');

if (accordions.length) {
  accordions.forEach(accordion => {
    const randomID = uniqueId();
    const target = $('.accordion__panel', accordion);
    const handler = $('.accordion__btn', accordion);

    setAttributes(handler, {
      id: `acc-btn-${randomID}`,
      'aria-controls': `acc-tab-${randomID}`,
    });

    setAttributes(target, {
      id: `acc-tab-${randomID}`,
      'aria-labelledby': `acc-btn-${randomID}`,
    });

    new Accordion({
      target,
      targetInner: $('.accordion__panel-inner', target),
      handler,
      easing: 'easeInOutQuart',
      duration: 400,
      initOpened: false,
    }).init();
  });
}
